import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AssetService } from 'src/app/shared/services/multi-clients/asset.service';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-cycle-type-selector',
    templateUrl: './cycle-type-selector.component.html',
    styleUrls: ['./cycle-type-selector.component.scss'],
    
})
export class CycleTypeSelectorComponent implements OnInit {
    public logoSrc = '';
    constructor(
        private _router: Router,
        private _modalController: ModalController,
        private _assetService: AssetService
    ) { 
        this.logoSrc = this._assetService.getLogoPath();
    }

    ngOnInit() { }

    public async goToAddCycle() {
        this._router.navigate(['performance-cycles/0'],{queryParams: {type: 'default'}});
        this.dismiss();

    }

    public async goToAddCyclePartner() {
        this._router.navigate(['performance-cycles/0'],{queryParams: {type: 'partner'}});
        this.dismiss();
    }
    public async dismiss(): Promise<void> {
        await this._modalController.dismiss();
    }

}
